import AppealIcon from "./Appeal_ICON.svg";
import ClarityIcon from "./Clarity_ICON.svg";
import CredibilityIcon from "./Credibility_ICON.svg";
import ExperienceIcon from "./Experience_ICON.svg";
import RelevanceIcon from "./Relevance_ICON.svg";

export const icons = {
    Appeal: AppealIcon,
    Clarity: ClarityIcon,
    Credibility: CredibilityIcon,
    Experience: ExperienceIcon,
    Relevance: RelevanceIcon
};

export const defaultIcon = AppealIcon;



// WEBPACK FOOTER //
// ./src/assets/svg/drivers/index.js